/**
 * 入力タイプでないバリデーションエラー時、メッセージだけ表示するコンポーネント
 */
export default {
    // see resources/views/components/_vue_html5_validation_message.blade.php
    template: '#html5_validation_message_template',
    data() {
        return {
        };
    },
    props: {
        // バリデーションフラグ
        is_valid: {
            type: Boolean,
            default: true,
            required: true
        },
        // 表示するメッセージ
        message: {
            type: String,
            default: '',
            required: true
        }
    },
    mounted: function() {
        this.updateCustomValidity();
    },
    computed: {
        validateMessage: function () {
            return (this.is_valid ? '' : this.message);
        }
    },
    watch: {
        // バリデーションフラグが更新されたらsetCustomValidityのメッセージを更新する
        is_valid: function () {
            this.updateCustomValidity();
        }
    },
    methods: {
        // setCustomValidityのメッセージを更新する
        updateCustomValidity: function () {
            this.$refs.input.setCustomValidity(this.validateMessage);
        }
    },
};
